// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"6f48e6fe","404":"5dbb7f61","408":"e64fa7d7"}[chunkId] + ".chunk.js";
};